__turbopack_context__.v({
  "letter": "CompanyLogoFallback-module-scss-module__1MUqcG__letter",
  "root": "CompanyLogoFallback-module-scss-module__1MUqcG__root",
});
